// App.js
import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Login from "./components/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import StockSearch from "./components/StockSearch";
import IsbnSearch from "./components/IsbnSearch";
import {Order} from "./components/Order";
import OrderSearch from "./components/OrderSearch";
import TransactionForm from "./components/TransactionForm";
import NewOrder from "./components/NewOrder";
import PostManager from "./components/PostManager";
import ThemeManager from "./components/ThemeManager";
import UserProfile from "./components/UserProfile";

const App = () => {
    return (
        <>
            {/* {axiosLoading && <Spinner />} */}
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<Login/>}/>
                        <Route path="/search" element={<IsbnSearch/>}/>
                        <Route path="/stockSearch" element={<StockSearch/>}/>
                        <Route path="/order" element={<OrderSearch/>}/>
                        <Route path="/order/:orderId" element={<Order/>}/>a
                        <Route path="/transaction" element={<TransactionForm/>}/>
                        <Route path="/profile" element={<UserProfile/>}/>
                        <Route path="/newOrder" element={<NewOrder/>}/>
                        <Route path="/instagramPost" element={<PostManager/>}/>
                        <Route path="/instagramPost/:postId" element={<PostManager/>}/>
                        <Route path="/theme" element={<ThemeManager/>}/>
                    </Routes>
                </div>
            </Router>
        </>
    );
};

export default App;
